<template>
  <div class="app-layout" >
    <app-sider />

    <section class="app-layout-main">
      <app-header />
      <app-body />
    </section>
  </div>
</template>

<script>
import {
  AppSider, AppHeader, AppBody,
} from '@/components/index';

export default {
  name: 'Layout',
  components: {
    AppSider,
    AppHeader,
    AppBody,
  },
//   mixins: [ResizeMixin],
//   computed: {
//     ...mapGetters('app', ['sidebar', 'device', 'screenSize']),
//     layoutClassName() {
//       const { screenSize, sidebar } = this.$store.state.app;
//       return {
//         [screenSize]: screenSize,
//         'sidebar-show': sidebar.opened,
//         'sidebar-hide': !sidebar.opened,
//         'without-animation': sidebar.withoutAnimation,
//       };
//     },
//   },
  // methods: {
  //   handleClickOutside() {
  //     this.closeSideBar({ withoutAnimation: false });
  //   },
  // },
};
</script>
<style lang="scss" scoped>
.app-layout-main {
  min-width: 800px;
}
</style>
